import styled from 'styled-components'

export const NotFoundContainer = styled.div`
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`

export const ContentWrapper = styled.div`
    transform: translateY(-50px);
`

export const Description = styled.p`
    text-align: center;
    padding-bottom: 24px;
`

export const ButtonWrapper = styled.div`
    width: 200px;
    height: 48px;
    border-radius: 4px;
    overflow: hidden;
`